module.exports = __webpack_public_path__ + "static/img/bg3.803f780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg/bg3.jpg
// module id = 516
// module chunks = 2